function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { captureException } from "@sentry/react";
import axios, { isCancel } from "axios";
import axiosRetry from "axios-retry";
import { Crisp } from "crisp-sdk-web";
// import MockAdapter from "axios-mock-adapter";
import { authActions, authSelectors } from "../redux/auth";
import { configSelectors } from "../redux/config";
import { isOnline } from "../features/app/utils";
httpClientProvider.store = null;
var csrfPromise;
var lastCsrfRefreshResponseTime = 0;
export default function httpClientProvider(store) {
    /**
     * Create the main HTTP Client
     */ var httpClient = axios.create({
        withCredentials: true,
        withXSRFToken: function(config) {
            return config.url.includes(configSelectors.apiHost(store.getState()));
        }
    });
    // const mock = new MockAdapter(httpClient);
    // mock.onGet("https://staging-api.robill.ro/v1/...").networkErrorOnce();
    var shouldGetCsrfAndRetryRequest = function(error) {
        var _error_response_data_errors, _error_response_data, _error_response;
        if (!(error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : (_error_response_data_errors = _error_response_data.errors) === null || _error_response_data_errors === void 0 ? void 0 : _error_response_data_errors.csrf)) {
            return false;
        }
        return error.response.status === 422 && error.response.data.errors.csrf === "invalid";
    };
    var notCanceledButGotNoResponse = function(error) {
        return !isCancel(error) && typeof error.response === "undefined";
    };
    axiosRetry(httpClient, {
        retries: 3,
        retryDelay: axiosRetry.exponentialDelay,
        retryCondition: function(error) {
            return notCanceledButGotNoResponse(error);
        }
    });
    httpClient.interceptors.request.use(function(config) {
        /**
            // Capture the request start time (in config) to ensure only a single CSRF refresh request is made when multiple requests fail.
            // This timestamp helps us determine if the request was sent before or after the latest CSRF refresh response.
            // If multiple requests fail with a CSRF error, only the first failing request triggers the CSRF refresh,
            // while others wait for it to complete, preventing redundant refresh requests.
             */ config.__startTimestamp = new Date().getTime();
        return config;
    }, function(error) {
        if (!isOnline) {
            return Promise.reject(new Error("noInternetConnection"));
        }
        if (notCanceledButGotNoResponse(error)) {
            captureException("A network error occurred after 3 retries");
            console.error("A network error occurred after 3 retries");
        }
        return Promise.reject(error);
    });
    /**
     * Ensure that when an error occurred, if it's a 403 error,
     * we refresh the auth token and then retry the initial request.
     */ httpClient.interceptors.response.use(null, /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(error) {
            var _error_response, status, config, currentRequestStartTime, currentReqStartedAfterLastCsrfRefreshResponse;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!error.response) {
                            return [
                                2,
                                Promise.reject(error)
                            ];
                        }
                        _error_response = error.response, status = _error_response.status, config = _error_response.config;
                        /**
         * If a request is made and fails with 401 and the user is logged in (meaning he made a request either by navigating
         * OR by submitting a form or just a custom API call...) then show the toaster expiration message + clear identity.
         * Since the user was logged in, the Private Layout will redirect the user to the login page.
         * When the user is trying to login2fa(step2) and it fails with 401, he has no identity
         * -> this case is treated in login2fa.jsx submit catch
         */ if (status === 401 && authSelectors.hasIdentity(store.getState())) {
                            store.dispatch(function(dispatch, getState, thunkOptions) {
                                thunkOptions.flashMessenger.setErrorMessage({
                                    message: thunkOptions.i18n.t("common.errors.session-expired")
                                });
                                var crispWebsiteId = configSelectors.crispWebsiteId(store.getState());
                                if (crispWebsiteId && Crisp.isCrispInjected()) {
                                    try {
                                        Crisp.session.reset(false);
                                    } catch (e) {
                                        console.error("crisp reset failed");
                                    }
                                }
                            });
                        }
                        if (status === 401) {
                            store.dispatch(authActions.clearIdentity());
                        }
                        if (!shouldGetCsrfAndRetryRequest(error)) return [
                            3,
                            3
                        ];
                        currentRequestStartTime = config.__startTimestamp;
                        //? Check if the current request started after the last CSRF refresh
                        //! Without this check, for slow networks and concurrent requests that will fail with 422 invalid csrf,
                        //! there would be multiple csrf refresh requests being made -> race condition
                        currentReqStartedAfterLastCsrfRefreshResponse = currentRequestStartTime > lastCsrfRefreshResponseTime;
                        if (!csrfPromise && currentReqStartedAfterLastCsrfRefreshResponse) {
                            csrfPromise = store.dispatch(authActions.getCsrfToken()).then(function() {
                                lastCsrfRefreshResponseTime = new Date().getTime();
                                csrfPromise = null; // Clear the promise after success
                            }).catch(function(err) {
                                csrfPromise = null; // Clear the promise on error
                                throw err; // Propagate the error if CSRF refresh fails
                            });
                        }
                        if (!csrfPromise) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            csrfPromise
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            httpClient.request(config)
                        ];
                    case 3:
                        return [
                            2,
                            Promise.reject(error)
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
    return httpClient;
}
